// extracted by mini-css-extract-plugin
module.exports = {"carouselPostGrid":"Layout--carouselPostGrid--2Ic43"};